export const reload = (setFilters) => {
    setTimeout(function(){setFilters(f => ({...f}))}, 300)
}